<template>
    <page>
        <module title="新人活动详情">
            <div v-if="activityInfo">
                <c-detail title="基础信息">
                    <c-detail-item label="活动名称">{{activityInfo.activity_name}}</c-detail-item>

                    <c-detail-item label="活动时间">{{activityInfo.begin_date}} - {{activityInfo.end_date}}</c-detail-item>

                    <c-detail-item label="限购数量">
                        单次下单限购
                        <span style="color: red">{{activityInfo.purchase_limit}}</span>
                        件
                    </c-detail-item>

                    <c-detail-item label="活动标签">{{activityInfo.tags}}</c-detail-item>

                    <c-detail-item label="下单数">{{activityInfo.order_count}}</c-detail-item>

                    <c-detail-item label="活动商品" full>
                        <c-table v-model="productList" height="auto" border>

                            <c-table-column
                                    label="商品信息"
                                    name="product_name"
                                    width="250"
                            >
                                <template v-slot="{data}">
                                    <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name" image-size="60"></product-info>
                                    <product-info v-else :image="data.product_img_url" :name="data.product_name" image-size="60"></product-info>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    label="原价"
                                    name="product_price"
                                    width="130"
                            >
                                <template v-slot="{data}">￥{{data.product_price}}</template>
                            </c-table-column>

                            <c-table-column
                                    label="活动价"
                                    name="sale_price"
                                    width="110"
                            >
                                <template v-slot="{data}">￥{{data.sale_price}}</template>
                            </c-table-column>

                            <c-table-column
                                    label="活动销量(总数)"
                                    name="sale_count"
                                    width="80"
                            >
                            </c-table-column>
                            <c-table-column
                                    label="商品状态"
                                    name="state"
                                    width="80"
                            >
                                <template v-slot="{data}">
                                    <span v-if="data.state == 1" style="color:red">禁用</span>
                                    <span v-if="data.state == 2" style="color:green">启用</span>
                                </template>
                            </c-table-column>
                        </c-table>
                    </c-detail-item>
                </c-detail>
            </div>
        </module>
    </page>
</template>

<script>
    import productInfo from '@/components/public/product_info.vue'
    import {mapState} from 'vuex'

    export default {
        name: 'activity_new_detail',

        props: {
            id: String
        },

        components: {
            productInfo
        },

        data() {
            return {
                activityInfo: '',
                userLevelStr: '',
                userLevelArr: [],
                productList: []
            }
        },

        computed: {
            ...mapState(['dict'])
        },

        watch: {
            id() {
                this.getActivityDetail();
            }
        },

        mounted() {
            this.getActivityDetail();
        },

        methods: {
            getActivityDetail() {
                this.request({
                    url: '/activity/new/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.activityInfo = data;
                        this.productList = data.product_list;
                    }
                });
          }
        }
    }
</script>